import React from 'react';
import { useNavigate } from 'react-router';

const Header = ({
	backgroundColor,
	primaryColor,
	secondaryColor,
	tertiaryColor,
	title,
	title2,
	subTitle,
	footerSubTitle,
	footerSubTitle2,
	btntxt,
	btnUrl,
	btntxt2,
	btnUrl2,
	imageUrl
}) => {
	const navigate = useNavigate();

	const handleNavigation = url => {
		if (url.startsWith('https://')) {
			window.open(url, '_blank');
		} else {
			navigate(url);
		}
	};

	return (
		<>
			<section style={{ backgroundColor }}>
				<div className="relative flex justify-center items-center">
					<div className="mx-auto max-w-5xl grid md:grid-cols-2 md:gap-8">
						{/* Image Section (1/2 width on md screens and up) */}
						<div className="relative h-224 md:h-auto">
							<img className="inset-0 h-full w-full object-cover" src={imageUrl} alt="header" />
						</div>

						{/* Content Section (1/2 width on md screens and up) */}
						<div className="px-6 md:px-20">
							<div className="mx-auto max-w-2xl py-24 sm:py-60">
								<h2
									className="mt-6 text-3xl font-bold tracking-tight sm:text-6xl"
									style={{ color: secondaryColor }}
								>
									{title.split('.').map((sentence, sentenceIndex) => (
										<div key={sentenceIndex}>
											{sentence.split(/(\[.*?\])/).map((part, index) => {
												if (part.startsWith('[') && part.endsWith(']')) {
													const insideText = part.slice(1, -1);
													return (
														<span key={index}>
															<span style={{ color: primaryColor }}>[</span>
															<span style={{ color: secondaryColor }}>{insideText}</span>
															<span style={{ color: primaryColor }}>]</span>
														</span>
													);
												}
												return part;
											})}
										</div>
									))}
								</h2>

								<p className="mt-16 text-xl leading-8" style={{ color: tertiaryColor }}>
									<b style={{ color: primaryColor }}>{title2}</b> {subTitle}
								</p>

								<div className="mt-28 max-w-xl text-base leading-7" style={{ color: tertiaryColor }}>
									<h1
										className="mt-6 text-3xl font-bold tracking-tight sm:text-4xl"
										style={{ color: primaryColor }}
									>
										{title2}
									</h1>

									<h1
										className="mt-6 text-3xl font-bold tracking-tight sm:text-xl"
										style={{ color: secondaryColor }}
									>
										{btntxt}
									</h1>

									<div className="mt-24">
										<button
											className="w-full mt-16 block rounded-md px-9 py-6 text-center text-sm font-semibold leading-6 border-1"
											style={{ color: primaryColor, borderColor: primaryColor }}
											onClick={() => handleNavigation(btnUrl)}
										>
											{btntxt}
										</button>
									</div>

									<p className="mt-24">{footerSubTitle}</p>
									<p className="mt-16">{footerSubTitle2}</p>

									<div className="mt-24">
										<button
											className="w-full mt-16 block rounded-md px-9 py-6 text-center text-sm font-semibold leading-6 border-1"
											style={{ color: primaryColor, borderColor: primaryColor }}
											onClick={() => handleNavigation(btnUrl2)}
										>
											{btntxt2}
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default Header;
